/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Highlights_Achievements_TitleInputs */

const en_us2_workout_highlights_achievements_title = /** @type {(inputs: Workout_Highlights_Achievements_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Achievement unlocked`);
	return /** @type {LocalizedString} */ (`Achievements unlocked`)
	
};

const pt_br2_workout_highlights_achievements_title = /** @type {(inputs: Workout_Highlights_Achievements_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Conquista desbloqueada`);
	return /** @type {LocalizedString} */ (`Conquistas desbloqueadas`)
	
};

const es_419_workout_highlights_achievements_title = /** @type {(inputs: Workout_Highlights_Achievements_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Logro desbloqueado`);
	return /** @type {LocalizedString} */ (`Logros desbloqueados`)
	
};

const pt_pt2_workout_highlights_achievements_title = /** @type {(inputs: Workout_Highlights_Achievements_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Conquista desbloqueada`);
	return /** @type {LocalizedString} */ (`Conquistas desbloqueadas`)
	
};

const fr_fr2_workout_highlights_achievements_title = /** @type {(inputs: Workout_Highlights_Achievements_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Succès débloqué`);
	return /** @type {LocalizedString} */ (`Succès débloqués`)
	
};

const de_de2_workout_highlights_achievements_title = /** @type {(inputs: Workout_Highlights_Achievements_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Erfolg freigeschaltet`);
	return /** @type {LocalizedString} */ (`Erfolge freigeschaltet`)
	
};

const it_it2_workout_highlights_achievements_title = /** @type {(inputs: Workout_Highlights_Achievements_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Traguardo sbloccato`);
	return /** @type {LocalizedString} */ (`Traguardi sbloccati`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "Achievement unlocked" |
* | * | "Achievements unlocked" |
*
* @param {Workout_Highlights_Achievements_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_achievements_title = /** @type {((inputs: Workout_Highlights_Achievements_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Achievements_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_achievements_title(inputs)
	if (locale === "es-419") return es_419_workout_highlights_achievements_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_achievements_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_achievements_title(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_achievements_title(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_achievements_title(inputs)
	return en_us2_workout_highlights_achievements_title(inputs)
});
export { workout_highlights_achievements_title as "workout-highlights.achievements_title" }